import React from "react";

function isCabinetNode(node) {
  const category = String(
    node?.category || node?.definition?.category || ""
  ).toLowerCase();

  return category.includes("cabinet.box") || category.includes("cabinet");
}

function makeLines(count, total) {
  const n = Number(count);
  const size = Number(total);

  if (!Number.isFinite(n) || n <= 1 || !Number.isFinite(size) || size <= 0) {
    return [];
  }

  return Array.from({ length: n - 1 }, (_, i) => ({
    id: Date.now() + i,
    offset: Math.round((size / n) * (i + 1)),
  }));
}

export default function FrontSimplePanel({
  selectedNode,
  resolvedNode,
  onChangeNode,
}) {
  const node = selectedNode || resolvedNode;

  if (!node || !isCabinetNode(resolvedNode || node)) {
    return null;
  }

  const effective = resolvedNode?.effectiveParameters || {};
  const width = Number(effective.width || 0);
  const height = Number(effective.height || 0);

  const partitions = node.partitions || {};
  const front = partitions.front || {
    horizontal: [],
    vertical: [],
    panelOverrides: {},
  };

  function updateFront(nextFront) {
    onChangeNode?.({
      id: node.id,
      partitions: {
        ...partitions,
        front: nextFront,
      },
    });
  }

  function setDoorCount(count) {
    updateFront({
      ...front,
      vertical: makeLines(count, width),
      horizontal: [],
      panelOverrides: {},
    });
  }

  function setDrawerCount(count) {
    updateFront({
      ...front,
      horizontal: makeLines(count, height),
      vertical: [],
      panelOverrides: {},
    });
  }

  function clearFront() {
    updateFront({
      horizontal: [],
      vertical: [],
      panelOverrides: {},
    });
  }

  function updateGap(key, value) {
    onChangeNode?.({
      id: node.id,
      parameterOverrides: {
        ...(node.parameterOverrides || {}),
        [key]: value === "" ? "" : Number(value),
      },
    });
  }

  return (
    <div className="border rounded p-3 bg-white space-y-3">
      <div>
        <div className="font-semibold text-sm">Front layout</div>
        <div className="text-xs text-slate-500">
          Brzo podešavanje vrata i fioka.
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2">
        <button
          type="button"
          onClick={() => setDoorCount(1)}
          className="px-3 py-2 border rounded bg-slate-50 text-sm"
        >
          1 Door
        </button>

        <button
          type="button"
          onClick={() => setDoorCount(2)}
          className="px-3 py-2 border rounded bg-slate-50 text-sm"
        >
          2 Doors
        </button>

        <button
          type="button"
          onClick={() => setDrawerCount(2)}
          className="px-3 py-2 border rounded bg-slate-50 text-sm"
        >
          2 Drawers
        </button>

        <button
          type="button"
          onClick={() => setDrawerCount(3)}
          className="px-3 py-2 border rounded bg-slate-50 text-sm"
        >
          3 Drawers
        </button>
      </div>

      <div className="grid grid-cols-2 gap-2">
        <div>
          <label className="text-xs text-slate-500">Outer gap</label>
          <input
            type="number"
            value={node.parameterOverrides?.frontGapOuter ?? ""}
            placeholder={String(effective.frontGapOuter ?? 2)}
            onChange={(e) => updateGap("frontGapOuter", e.target.value)}
            className="w-full px-2 py-1 border rounded text-sm"
          />
        </div>

        <div>
          <label className="text-xs text-slate-500">Inner gap</label>
          <input
            type="number"
            value={node.parameterOverrides?.frontGapInner ?? ""}
            placeholder={String(effective.frontGapInner ?? 2)}
            onChange={(e) => updateGap("frontGapInner", e.target.value)}
            className="w-full px-2 py-1 border rounded text-sm"
          />
        </div>
      </div>

      <button
        type="button"
        onClick={clearFront}
        className="w-full px-3 py-2 border rounded bg-white text-sm text-red-600"
      >
        Clear front
      </button>
    </div>
  );
}